import baseMoment from 'moment'
import { isWeekDay, isWeekendDay } from 'moment-business'
import { extendMoment } from 'moment-range'

// @ts-ignore
const moment = extendMoment(baseMoment)

// 今年假日 (原本為平日，調整為假日)
const holidayList = [
  '2025-01-01', // 元旦 (週三)
  '2025-01-27', // 春節連假 (週一)
  '2025-01-28', // 除夕 (週二)
  '2025-01-29', // 春節 (週三)
  '2025-01-30', // 春節 (週四)
  '2025-01-31', // 春節 (週五)
  '2025-02-28', // 和平紀念日 (週五)
  '2025-04-03', // 兒童節補假 (週四)
  '2025-04-04', // 兒童節 (週五)
  '2025-05-01', // 勞動節 (週四)
  '2025-05-30', // 端午節補假 (週五)
  '2025-09-29', // 教師節補假 (週一)
  '2025-10-06', // 中秋節 (週一)
  '2025-10-10', // 國慶日 (週五)
  '2025-10-24', // 光復節補假 (週五)
  '2025-12-25', // 行憲紀念日 (週四)
  '2026-01-01', // 元旦 (週四)
  '2026-02-16', // 除夕 (週一)
  '2026-02-17', // 春節 (週二)
  '2026-02-18', // 春節 (週三)
  '2026-02-19', // 春節 (週四)
  '2026-02-20', // 春節補假 (週五)
  '2026-02-27', // 和平紀念日補假 (週五)
  '2026-04-03', // 兒童節補假 (週五)
  '2026-04-06', // 清明節補假 (週一)
  '2026-05-01', // 勞動節 (週五)
  '2026-06-19', // 端午節 (週五)
  '2026-09-25', // 中秋節 (週五)
  '2026-09-28', // 教師節 (週一)
  '2026-10-09', // 國慶日補假 (週五)
  '2026-10-26', // 光復節補假 (週一)
  '2026-12-25', // 行憲紀念日 (週五)
]

// 今年補班日
const forceBusinessDayList = [
  '2025-02-08', // 春節連假補班日
]

// 確認是否為國定假日
export function isHoliday(date: moment.Moment) {
  return holidayList.reduce(
    (pre, cur) => pre || date.isSame(moment(cur), 'd'),
    false,
  )
}

// 確認是否為補班日
export function isForceBusinessDay(date: moment.Moment) {
  return forceBusinessDayList.reduce(
    (pre, cur) => pre || date.isSame(moment(cur), 'd'),
    false,
  )
}

// 計算下個工作日
export function addWeekDaysWithHoliday(date: moment.Moment, amount: number) {
  let nextDate = date

  while (amount > 0) {
    nextDate = moment(nextDate).add(1, 'days')
    if (
      // 不是假日
      !isHoliday(nextDate)
      // 是平日或補班日
      && (isWeekDay(nextDate) || isForceBusinessDay(nextDate))
    )
      amount = amount - 1
  }

  // 回傳下個工作日
  return nextDate
}

// 計算兩個日期間有幾個國定假日
export function countHolidays(startDate, endDate) {
  let count = 0
  const list = Array.from(
    moment.range(moment(startDate), moment(endDate)).by('days'),
  )

  for (const date of list) {
    if (isHoliday(date))
      count = count + 1
  }

  return count
}

// 計算兩個日期間有幾個補班日
export function countForceBusinessDay(startDate, endDate) {
  let count = 0
  const list = Array.from(
    moment.range(moment(startDate), moment(endDate)).by('days'),
  )

  for (const date of list) {
    if (isForceBusinessDay(date))
      count = count + 1
  }

  return count
}

// 計算兩個日期間有幾個放假日
export function countHolidayAndWeekendDay(startDate, endDate) {
  let count = 0
  const list = Array.from(
    moment.range(moment(startDate), moment(endDate)).by('days'),
  )

  for (const date of list) {
    if (isHoliday(date) || (!isForceBusinessDay(date) && isWeekendDay(date)))
      count = count + 1
  }

  return count
}
